/*
 * PERFUM by Aleja — Cart Drawer Recommended Products
 * Web component that handles add-to-cart for recommended products
 * inside the cart drawer. Integrates with Dawn's cart drawer update system.
 */

class PerfumCartRecAdd extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    if (this.button) {
      this.button.addEventListener('click', this.onAddClick.bind(this));
    }
  }

  async onAddClick(event) {
    event.preventDefault();
    const variantId = this.dataset.variantId;
    if (!variantId) return;

    this.setLoadingState(true);

    try {
      const response = await fetch(
        (window.Shopify?.routes?.root || '/') + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId), quantity: 1 }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Error al agregar al carrito');
      }

      const data = await response.json();

      /* Brief success feedback */
      this.setSuccessState();

      /* Update the cart drawer via Dawn's built-in renderContents */
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && data.sections) {
        cartDrawer.renderContents({
          sections: data.sections,
          id: data.items ? data.items[0].id : variantId,
        });
      }

      /* Publish cart update event for other listening components */
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'perfum-cart-rec',
          cartData: data,
        });
      }
    } catch (error) {
      console.error('[PERFUM] Error adding to cart:', error);
      this.setLoadingState(false);
    }
  }

  setLoadingState(loading) {
    if (!this.button) return;
    if (loading) {
      this.button.classList.add('loading');
      this.button.disabled = true;
    } else {
      this.button.classList.remove('loading');
      this.button.disabled = false;
    }
  }

  setSuccessState() {
    if (!this.button) return;
    this.button.classList.remove('loading');
    this.button.classList.add('added');
    this.button.disabled = true;
  }
}

if (!customElements.get('perfum-cart-rec-add')) {
  customElements.define('perfum-cart-rec-add', PerfumCartRecAdd);
}
